/**
 * Cari kartında listelerde gösterilecek isim: önce firma adı, boşsa ad soyad.
 */
export function currentAccountDisplayName(account) {
  if (!account) return '';
  const company = (account.companyName || '').trim();
  if (company) return company;
  return (account.fullName || '').trim();
}

/**
 * Ödeme / tahsilat formu vb.: görünür metinde ad soyad öncelikli, boşsa firma adı.
 */
export function currentAccountPersonFirst(account) {
  if (!account) return '';
  const fullName = (account.fullName || '').trim();
  if (fullName) return fullName;
  return (account.companyName || '').trim();
}

/**
 * Backend raw bakiye → ekran bakiyesi (Cari Hesaplar ile aynı).
 * Raw pozitif = borç/verecek → display negatif (kırmızı).
 * Raw negatif = alacak → display pozitif (yeşil).
 */
export function toCariDisplayBalance(raw) {
  return -Number(raw || 0);
}

/**
 * Fiş/irsaliye özet Toplam: hareketin cari etkisi display uzayında.
 * Raw totalPrice / totalInAccountCurrency ile aynı flip (Devir + Toplam = Güncel korunur).
 */
export function toCariDisplayDocumentTotal(rawTotal) {
  return toCariDisplayBalance(rawTotal);
}

/**
 * API Borç/Alacak (debit = |totalPrice| if <0, credit = totalPrice if >0)
 * → display kolonları (şirket bakış: borç − / alacak +).
 * Satınalma/örme gelen (raw +) → Borç'ta negatif; ödeme (raw −) → Alacak'ta pozitif.
 */
export function toCariDisplayLedgerColumns(rawDebit, rawCredit) {
  const rawSigned = Number(rawCredit || 0) - Number(rawDebit || 0);
  const displayAmount = toCariDisplayBalance(rawSigned);
  if (displayAmount < 0) {
    return { displayDebit: displayAmount, displayCredit: 0 };
  }
  if (displayAmount > 0) {
    return { displayDebit: 0, displayCredit: displayAmount };
  }
  return { displayDebit: 0, displayCredit: 0 };
}

/**
 * Renk sınıfları **display** bakiyeye göre (>0 yeşil alacak, <0 kırmızı borç).
 * @param {number} displayBalance - toCariDisplayBalance sonucu
 * @param {'table'|'modal'|'strip'} [variant='table']
 */
export function getCariDisplayBalanceClassName(displayBalance, variant = 'table') {
  const n = Number(displayBalance || 0);

  if (variant === 'modal') {
    if (n > 0) return 'text-green-600';
    if (n < 0) return 'text-red-600';
    return 'text-gray-700';
  }

  if (variant === 'strip') {
    if (n > 0) return 'text-green-600 dark:text-green-400';
    if (n < 0) return 'text-red-600 dark:text-red-400';
    return 'text-gray-600 dark:text-gray-300';
  }

  // table (Cari Hesaplar / hareket listeleri)
  if (n > 0) return 'text-emerald-600 dark:text-emerald-400';
  if (n < 0) return 'text-rose-600 dark:text-rose-400';
  return 'text-gray-800 dark:text-gray-200';
}
